import { Widget } from '../widget/widget';

export class DropdownWidget extends Widget {
    async validate(): Promise<boolean> {
        this.clearError();

        let valid = true;

        if (this.required && this.$input.value === '0') {
            this.displayError('widget.is_required');
            valid = false;
        }

        return valid;
    }

    async getValue(): Promise<string> {
        return this.$input.value;
    }
}
